import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJumlahTanggungan } from "@/services/getData"

export default function MasterJumlahTanggunganPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJumlahTanggungan"],
    queryFn: getListJumlahTanggungan,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
